import styled from "styled-components";

import { themeGet } from "@styled-system/theme-get";

const FooterListItem = styled("li")(props => {
  return {
    display: "flex",
    alignItems: "center",
    "&:not(:first-of-type)": {
      marginTop: props.withIcon ? "4px" : "12px",
    },
    a: {
      textDecoration: "underline",
      fontSize: themeGet("fontSizes.0")(props),
      lineHeight: props.withIcon ? "18px" : themeGet("fontSizes.1")(props),
      color: themeGet("colors.footer.link")(props),
      "&:hover": {
        textDecoration: "none",
      },
    },
  };
});

FooterListItem.displayName = "FooterListItem";

export default FooterListItem;
